import React from "react";
import NewPageIcon from "../Assets/NewPageIcon";
import "./style.css";
function Headers({ header }) {
  const { heading, link, subHeading, description, isSubHeading, howItWorks } =
    header;
  return (
    <div className="headerCommon">
      <p className="heading">{heading}</p>
      <a
        className="linkNotUnderlined"
        href={link}
        target="_blank"
        rel="noreferrer"
      >
        {howItWorks ?? "How it works?"}
        <span className="newPageIcon">
          <NewPageIcon />
        </span>
      </a>
      {isSubHeading ? (
        <div className="subHeadingCommon">
          <div className="subHeading">{subHeading}</div>
          <div className="description">{description}</div>
        </div>
      ) : null}
    </div>
  );
}

export default Headers;
